import theme from "@/styles/scss/theme.module.scss";

const handleLabel = (value?: string, hideLabel?: boolean): any => {
  if (!value || hideLabel) {
    console.log("hideLabel", value, hideLabel);
    return {
      "& .MuiOutlinedInput-notchedOutline > legend > span": {
        display: "none !important",
      },
      "& .MuiInputLabel-shrink": {
        display: "none !important",
      },
    };
  }
  return {
    "& .MuiInputLabel-root": {
      top: "2px !important",
    },
  };
};

const themeStyle = (isDark: boolean | undefined) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.secondaryMain,
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: isDark ? theme.errorMain : theme.secondaryMain,
  },
  "& .MuiInputBase-input": {
    backgroundColor: "transparent",
  },
  "& .MuiSelect-select": {
    backgroundColor: theme.secondaryMain,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: isDark ? undefined : "none !important",
  },
});

const checkboxStyle = (isDark: boolean | undefined) => ({
  "& .MuiSwitch-switchBase": {
    color: theme.secondaryMain,
    "&.Mui-checked": {
      color: isDark ? theme.primaryMain : theme.secondaryMain,
      "& + .MuiSwitch-track": {
        backgroundColor: isDark ? theme.primaryMain : theme.secondaryMain,
        border: `2px solid ${isDark ? theme.primaryMain : theme.secondaryMain}`,
        marginTop: "-1px",
      },
    },
    "& + .MuiSwitch-thumb": {
      color: isDark ? theme.primaryMain : theme.secondaryMain,
      border: `2px solid ${isDark ? theme.primaryMain : theme.secondaryMain}`,
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: theme.primaryMain,
    border: `2px solid ${isDark ? theme.primaryMain : theme.secondaryMain}`,
    marginTop: "-1px",
  },
  "& .MuiSwitch-thumb": {
    border: `1px solid ${isDark ? theme.primaryMain : theme.secondaryMain}`,
  },
});

export default {
  handleLabel,
  themeStyle,
  checkboxStyle,
};
